import { Card, Empty, Flex, Skeleton } from "antd";
import React from "react";
import { JobDescription } from "../../../Entities/job-description.entity";
import JobCard from "./JobCard";

interface AllJobsProps {
  jobDescriptions: JobDescription[];
  handleViewDetails: (id: string) => void;
  handleApply: (id: string) => void;
  appliedJobIds: string[];
}

const AllJobs: React.FC<AllJobsProps> = ({
  jobDescriptions,
  handleViewDetails,
  handleApply,
  appliedJobIds,
}) => {
  return jobDescriptions.length > 0 ? (
    <>
      {jobDescriptions.map((item) => (
        <>
          {item ? (
            <JobCard
              appliedJobIds={appliedJobIds}
              key={item._id}
              jobDescription={item}
              handleViewDetails={() => handleViewDetails(item._id)}
              handleApply={handleApply}
            />
          ) : (
            <Card>
              <Skeleton active paragraph={{ rows: 4 }} />
            </Card>
          )}
        </>
      ))}
    </>
  ) : (
    <Flex align="center" justify="center" style={{ height: "50vh" }}>
      <Empty
        image={Empty.PRESENTED_IMAGE_SIMPLE}
        description="No Jobs Found"
      ></Empty>
    </Flex>
  );
};

export default AllJobs;
